module.exports = __webpack_public_path__ + "static/media/glowing-container.90cd8400.png";